<template>
  <ClassroomStats :classroomId="classroomId" />
</template>

<script>
import ClassroomStatsStoreModule from "@/developing/store/modules/classroom-stats";
const StoreModule = ClassroomStatsStoreModule;
const StoreModuleName = "ClassroomStats";

export default {
  components: {
    ClassroomStats: () => import("@/developing/components/classroom-stats")
  },
  props: {
    classroomId: {
      type: String,
      default: null
    }
  },
  beforeCreate() {
    if (!this.$store.state.ClassroomStats) this.$store.registerModule(StoreModuleName, StoreModule);
  },
  destroyed() {
    this.$store.unregisterModule(StoreModuleName);
  },
}
</script>
